import React from 'react';
import PropTypes from 'prop-types';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';

const colorProp = {
  pending: 'muted',
  approved: 'primary',
  rejected: 'error',
  regular: 'regular',
};

const StepIcon = ({
  icon,
  status,
  isVertical,
  showSeparator,
  isLastSeparator,
}) => {
  return (
    <>
      <div className={`timeline__step timeline__step--${status}`}>
        <BetaIcon
          name={icon}
          size={IconSizes[28]}
          color={IconColors[colorProp[status]]}
        />
      </div>
      {showSeparator && (
        <div
          className={`timeline__separator${isVertical ? '--vertical' : ''}${
            status ? `--${status}` : ''
          }${isLastSeparator ? '--last' : ''}`}
        />
      )}
    </>
  );
};

const Timeline = ({ timelineSteps, isVertical = false }) => {
  return (
    <div>
      <div className={`timeline__wrapper${isVertical ? '--vertical' : ''}`}>
        {timelineSteps.map((step, index) => {
          const isLastSeparator = index === timelineSteps.length - 2;
          const showSeparator = index < timelineSteps.length - 1;
          const title = step && step.title ? step.title : null;
          const description =
            step && step.description ? step.description : null;

          return isVertical ? (
            <div className="d-flex gap-2xs" key={index}>
              <div className="d-flex flex-column">
                <StepIcon
                  icon={step.icon}
                  status={step.status}
                  isVertical={isVertical}
                  showSeparator={showSeparator}
                  isLastSeparator={isLastSeparator}
                />
              </div>
              {title.text && (
                <div className="d-flex flex-column">
                  <div className="pt-3xs">
                    {title.bold ? <b>{title.text}</b> : title.text}
                  </div>
                  {description && <div>{description}</div>}
                </div>
              )}
            </div>
          ) : (
            <div
              className={`d-flex items-center ${showSeparator ? 'w-33%' : ''}`}
              key={index}
            >
              <StepIcon
                icon={step.icon}
                status={step.status}
                isVertical={isVertical}
                showSeparator={showSeparator}
                isLastSeparator={isLastSeparator}
              />
            </div>
          );
        })}
      </div>
      {!isVertical && (
        <div className="d-flex justify-between pt-2xs">
          {timelineSteps.map((step, index) => {
            const title = step && step.title ? step.title : null;
            if (title.text) {
              return (
                <div className="text-center w-100%" key={index}>
                  {title.bold ? <b>{title.text}</b> : title.text}
                </div>
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

Timeline.propTypes = {
  timelineSteps: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export { Timeline };
